import { render, staticRenderFns } from "./LanguagesOfFinland.vue?vue&type=template&id=54450bcb&"
import script from "./LanguagesOfFinland.vue?vue&type=script&lang=js&"
export * from "./LanguagesOfFinland.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesOfFinland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports